<ion-header mode="ios">
  <ion-toolbar mode="ios" color="light">
    <ion-title>{{ title }}</ion-title>
    <ion-buttons slot="start">
      <ion-button mode="ios" fill="clear" (click)="dismiss()" aria-label="Close filters">
        <ion-icon color="dark" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-list lines="none" mode="ios">
    <h6 class="ion-text-left ion-padding-start">Status</h6>
    <ion-radio-group mode="md" [(ngModel)]="status">
      <ion-item mode="ios" (click)="status = 'active'" data-testid="public-content-status-active">
        <ion-label>Active</ion-label>
        <ion-radio slot="start" class="custom-radio" mode="md" value="active" color="warning"></ion-radio>
      </ion-item>
      <ion-item mode="ios" (click)="status = 'archived'" data-testid="public-content-status-archived">
        <ion-label>Archived</ion-label>
        <ion-radio slot="start" class="custom-radio" mode="md" value="archived" color="warning"></ion-radio>
      </ion-item>
    </ion-radio-group>
  </ion-list>
</ion-content>

<ion-footer mode="ios">
  <ion-grid class="ion-no-padding">
    <ion-row>
      <ion-col sizeXl="2.5" sizeLg="2.5" sizeMd="1" sizeSm="0" sizeXs="0"></ion-col>
      <ion-col sizeXl="7" sizeLg="7" sizeMd="10" sizeSm="12" sizeXs="12">
        <ion-row>
          <ion-col size="6">
            <ion-button mode="ios" color="warning" expand="full" shape="round" (click)="apply()" data-testid="public-content-filter-apply">
              Apply
            </ion-button>
          </ion-col>
          <ion-col size="6">
            <ion-button mode="ios" color="warning" expand="full" shape="round" (click)="clear()" data-testid="public-content-filter-clear">
              Clear
            </ion-button>
          </ion-col>
        </ion-row>
      </ion-col>
      <ion-col sizeXl="2.5" sizeLg="2.5" sizeMd="1" sizeSm="0" sizeXs="0"></ion-col>
    </ion-row>
  </ion-grid>
</ion-footer>
